import tw, { styled } from 'twin.macro';
import { variants } from '@/components/Link/Link.styles';

export const StyledSRText = styled.span`
  ${tw`sr-only`};
`;

export const SearchNavWrapper = styled.div`
  ${tw`flex items-center`}
  ${tw`h-full`}
`;

export const SearchButton = styled.button`
  ${variants.nav_text_link}
`;
